<script setup lang="ts">
import { mdiChevronRight } from "@mdi/js";
import {
	DropdownMenuPortal,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
} from "reka-ui";
import type { ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import { Icon } from "../icon";

interface Props extends ClassProps {
	offset?: number;
}

const props = withDefaults(defineProps<Props>(), { offset: 4 });

defineSlots<{
	default(): void;
	trigger(): void;
}>();
</script>

<template>
	<DropdownMenuSub>
		<DropdownMenuSubTrigger as="li">
			<div>
				<slot name="trigger" />
				<Icon class="ml-auto" size="sm" :d="mdiChevronRight" />
			</div>
		</DropdownMenuSubTrigger>

		<DropdownMenuPortal>
			<DropdownMenuSubContent
				as="ul"
				:sideOffset="offset"
				:class="cn('menu popover popover-animate min-w-32 gap-1', props.class)"
			>
				<slot />
			</DropdownMenuSubContent>
		</DropdownMenuPortal>
	</DropdownMenuSub>
</template>
